import { ERP } from '../_base/endpoint';
import axios from 'axios';

import global from '../../common/utility/global';

class ReporteCuentasCobrarService {

    /******* QUERIES ******/

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}credito-cobranza/reporte-cuentas-cobrar/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async reporteResumen(filter) {
        const response = await axios
            .get(`${ERP}credito-cobranza/reporte-cuentas-cobrar/resumen?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async reporteDetallado(filter) {
        const response = await axios
            .get(`${ERP}credito-cobranza/reporte-cuentas-cobrar/detallado?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };




}

export default new ReporteCuentasCobrarService();